<template>
  <div class="admin-cont">
    <div class="admin_nav" v-show="fullWidth">
      <div class="admin_nav_site">
        <ul v-for="(item, index) in menuList" :key="index">
          <li
            @click="handleToTitle(index, item, 1)"
            @mouseenter="changeTitleColor(index)"
            @mouseleave="removeTitleColor(index)"
            class="first-menu"
            ref="title"
            :class="{ active: currentSort === index }"
          >
            <div class="left-title">
              {{ item.name }}
            </div>
            <div class="right-icon">
                <i :class="'el-icon-arrow-' + item.close"></i>
            </div>
          </li>
          <li
            v-for="(subItem, subIndex) in item.children"
            :key="subIndex" v-show="item.isSubShow"
            class="sub-nav"
          >
            <div
              class="subitem"
              :class="{
                active:
                  currentSort === index &&
                  currentSubSort === subIndex &&
                  currentSubChildSort == -1
              }"
            >
              <div class="sub-icon">
                <i class="iconfont" :class="`${subItem.imageName}`"></i>
              </div>
              <div
                class="sub-title"
                @click="handleMenuClick(index, subItem.routeUrl, subIndex, -1)"
                v-if="!subItem.children || subItem.children && subItem.children.length == 0"
              >
                {{ subItem.name }}
              </div>
              <div
                class="sub--child-title"
                v-else
                @click="handleToTitle(index, item, 2, subIndex)"
              >
                <div class="left-title">
                  {{ subItem.name }}
                </div>
                <div class="right-icon">
                    <i :class="'el-icon-arrow-' + subItem.close"></i>
                </div>
              </div>
            </div>
            <template v-if="subItem.children && subItem.children.length > 0 && subItem.isSubShow">
              <div
                v-for="(grandeItem, grandeItemIndex) in subItem.children"
                class="grande-cont"
                :key="grandeItemIndex"
                :class="{
                  subChildActive:
                    currentSort === index &&
                    currentSubSort === subIndex &&
                    currentSubChildSort == grandeItemIndex
                }"
              >
                <div
                  class="grandeItem"
                  @click="
                    handleMenuClick(
                      index,
                      grandeItem.routeUrl,
                      subIndex,
                      grandeItemIndex
                    )
                  "
                >
                  {{ grandeItem.name }}
                </div>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import UserPersistence from "../../../persistence/UserPersistence";
import ArrayUtils from "../../../libs/utils/ArrayUtils";
import DataUtils from "../../../libs/utils/DataUtils";
import _ from "../../../libs/utils/ObjectUtils";
import api from "../../../api/UserApi";
import { routers } from "../../../router/router";
import { moduleId } from "../../../store/modules/account-info";
import {isEduKS} from "../../../libs/check";

export default {
    name: "z-menu",
    data() {
        return {
            currentSort: 0,
            currentSubSort: -1,
            currentSubChildSort: "",
            pagetype: "index",
            fullWidth: true,
            dismenu: true,
            menuList:[],
        };
    },
    computed: {
        ...mapState("user", {
            userMenuList: (state) => state.menuList,
        }),
    },
    watch: {
        $route() {
              this.updateActiveMenuIndex();
        },
        userMenuList() {
            this.updateMenu();
        },
        menuList() {
          this.updateActiveMenuIndex();
        }
    },
    methods: {
        ...mapMutations("user", ["updateMenuList"]),
        ...mapMutations(moduleId, ["setRouterKey"]),

        handleGetMenu() {
            let data = UserPersistence.getMenuIndex();
            (this.currentSort = data.currentSort),
                (this.currentSubSort = data.currentSubSort),
                (this.currentSubChildSort = data.currentSubChildSort);

            if (this.currentSort >= 0) {
                this.menuList[this.currentSort].isSubShow = true;
                this.menuList[this.currentSort].close = "up";
            }
            if (this.currentSubSort && this.currentSubChildSort >= 0) {
                this.menuList[this.currentSort].isSubShow = true;
                this.menuList[this.currentSort].close = "up";
            }
        },
        handleSaveMenuIndex() {
            let params = {
                currentSort: this.currentSort,
                currentSubSort: this.currentSubSort,
                currentSubChildSort: this.currentSubChildSort,
            };

            UserPersistence.saveMenuIndex(params);
        },
        active(index) {
            this.currentSort = index;
        },
        async handleQuit() {
            let res = await api.logout();
            if (res.code == 0) {
                UserPersistence.clear();
                localStorage.clear();
                sessionStorage.clear();
                this.$router.push({ path: "login" });
            }
            // this.logout();
        },
        changeTitleColor(index) {
            // this.currentSort = index;
        },
        removeTitleColor(index) {
            // this.currentSort = null;
        },
        handleToTitle(ind, item, type, subIndex) {
            if (type == 1) {
                this.menuList[ind].isSubShow = !this.menuList[ind].isSubShow;
                if (this.menuList[ind].isSubShow == true) {
                    this.menuList[ind].close = "up";
                } else {
                    this.menuList[ind].close = "down";
                }
            } else {
                this.currentSort = ind;
                this.currentSubSort = subIndex;
                this.menuList[ind].children[subIndex].isSubShow =
                    !this.menuList[ind].children[subIndex].isSubShow;
                if (this.menuList[ind].children[subIndex].isSubShow == true) {
                    this.menuList[ind].children[subIndex].close = "up";
                } else {
                    this.menuList[ind].children[subIndex].close = "down";
                }
                this.handleSaveMenuIndex();
            }
        },
        handleMenuClick(navIndex, name, subIndex, subchildIndex) {
            this.currentSort = navIndex;
            this.currentSubSort = subIndex;
            this.currentSubChildSort = subchildIndex;
            this.handleSaveMenuIndex();

            this.$router.push({
                name: name,
            });

            // if (name === this.$route.name) {
                this.setRouterKey();
            // }
        },
        updateActiveMenuIndex() {
            let activeMenu = DataUtils.breadthTreeQuery(
                this.menuList,
                "name",
                this.$route.name
            );
            if (!activeMenu) {
                this.currentSort = -1;
                return;
            }
            let parentTree = DataUtils.findParentTree(
                this.menuList,
                "id",
                activeMenu.id
            );
            this.currentSort = ArrayUtils.getItemIndex(
                this.menuList,
                "id",
                parentTree.id
            );
            this.currentSubSort = ArrayUtils.getItemIndex(
                parentTree.children,
                "id",
                activeMenu.id
            );
            let childrenList =
                parentTree.children[this.currentSubSort] !== undefined
                    ? parentTree.children[this.currentSubSort].children
                    : [];
            if (childrenList.length > 0) {
                this.currentSubChildSort = ArrayUtils.getItemIndex(
                    childrenList,
                    "id",
                    activeMenu.id
                );
            }
        },
        updateMenu() {
            let menu = [];
            if (this.userMenuList.length > 0) {
                menu = _.cloneDeep(this.userMenuList);
            } else {
                menu = _.cloneDeep(UserPersistence.getBaseInfo().menuList);
            }
            this.menuList = menu
                ? DataUtils.listToTree(menu, "parentId", "id")
                : [];
            this.menuList.forEach(item=>{
              this.$set(item,"isSubShow",true);
              this.$set(item,"close","up");
            })
        },
    },
    created() {
        this.updateMenu();
        this.updateActiveMenuIndex();
    },
    mounted() {
        window.addEventListener("load", this.handleGetMenu);
        //全系统键盘按下事件
        let component = this;
        window.document.onkeydown = function (event) {
            event = window.event || event;
            let key = event.keyCode;
            if (
                (event.ctrlKey && key === 83) ||
                key === 113 ||
                key === 174 ||
                key === 114 ||
                key === 175 ||
                key === 115 ||
                key === 117 ||
                key === 176
            ) {
                if (event && event.preventDefault) {
                    event.preventDefault();
                } else {
                    event.returnValue = false;
                }
            }

            // 122  F11 123 F12  27 esc
            if (
                (key === 27 ||
                    key === 122 ||
                    key === 123 ||
                    key === 91 ||
                    (event.ctrlKey && event.shiftKey && key === 46) ||
                    (event.altKey &&
                        (key !== 78 || !(key > 47 && key < 58)))) &&
                window != top &&
                isEduKS()
            ) {
                console.log("finance-web ---> blur");
                parent.postMessage({ type: "blur" }, "*");
            }
        };
        window.document.onkeyup = function (event) {
            event = window.event || event;
            let key = event.keyCode;
            //ctr+s
            if (event.ctrlKey && key === 83) {
                eventBus.$emit("addVoucherSave", key); //新增凭证--保存凭证
            }
            //alt+n
            if (event.altKey && key === 78) {
                eventBus.$emit("addVoucherNew", key); //新增凭证--新增凭证
            }
            //F2
            if (key === 113 || key === 174) {
                eventBus.$emit("addVoucherNewAndSave", key); //新增凭证--保存并新增
            }
            //F3
            if (key === 114 || key === 175) {
                eventBus.$emit("addVoucherSaveTemplate", key); //新增凭证--存为常用凭证
            }
            //F4
            if (key === 115) {
                eventBus.$emit("addVoucherFromTemplate", key); //新增凭证--从常用凭证生成
            }

            if (
                (key === 27 ||
                    key === 122 ||
                    key === 123 ||
                    key === 91 ||
                    (event.ctrlKey && event.shiftKey && key === 46) ||
                    (event.altKey &&
                        (key !== 78 || !(key > 47 && key < 58)))) &&
                window != top &&
                isEduKS()
            ) {
                console.log("finance-web ---> blur");
                parent.postMessage({ type: "blur" }, "*");
            }
        };
    },
    beforeDestroy() {
        window.removeEventListener("load", this.handleGetMenu);
        window.document.onkeydown = function (event) {
            event = window.event || event;
            let key = event.keyCode;
            if (
                (key === 27 ||
                    key === 122 ||
                    key === 123 ||
                    key === 91 ||
                    (event.ctrlKey && event.shiftKey && key === 46) ||
                    (event.altKey &&
                        (key !== 78 || !(key > 47 && key < 58)))) &&
                window != top &&
                isEduKS()
            ) {
                console.log("finance-web ---> blur");
                parent.postMessage({ type: "blur" }, "*");
            }
        };
        window.document.onkeyup = function (event) {
            event = window.event || event;
            let key = event.keyCode;
            if (
                (key === 27 ||
                    key === 122 ||
                    key === 123 ||
                    key === 91 ||
                    (event.ctrlKey && event.shiftKey && key === 46) ||
                    (event.altKey &&
                        (key !== 78 || !(key > 47 && key < 58)))) &&
                window != top &&
                isEduKS()
            ) {
                console.log("finance-web ---> blur");
                parent.postMessage({ type: "blur" }, "*");
            }
        };
    },
};
</script>

<style scoped lang="scss">
.admin-cont {
    height: 100%;
    width: 230px;
    padding-top: 10px;
    box-sizing: border-box;

    .admin_nav {
        height: calc(100vh - 130px);
        padding-left: 7px;
        background: #111d3b;
        position: relative;
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        box-sizing: border-box;
        overflow-y: auto;
        padding-bottom: 10px;

        .subitem {
            width: 100%;
            display: flex;
            padding-left: 15px;
            box-sizing: border-box;
            &:hover {
                background: #434855;
                border-radius: 3px;
            }
            &.active {
                background: #215de8;
                border-radius: 3px;
                color: #ffffff;
                .sub-icon {
                    .icon-color {
                        color: #ffffff;
                    }
                }
            }
        }
        .admin_nav_site {
            // height: 85vh;
        }
        .nav-active {
            color: #ffffff;
        }
        .sub--child-title {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .right-icon {
                width: 17%;
            }
        }
        ul li {
            // height: 36px;
            line-height: 36px;
            display: block;
            // display: flex;
            // justify-content: center;
            // align-items: start;
            cursor: pointer;
            box-sizing: border-box;
            padding: 0 10px;
            &.first-menu:hover {
                .left-title {
                    color: #ffffff;
                }
                .right-icon {
                    color: #ffffff;
                }
            }
        }
        .sub-nav {
            .sub-icon {
                width: 17%;
                .icon-color {
                    color: #bec5c0;
                }
            }
            .sub-title {
                width: 78%;
                font-size: 14px;
            }
        }
        ul li:first-child {
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #fff;
            cursor: pointer;
            &.active {
                .left-title {
                    color: #ffffff;
                }
                .right-icon {
                    color: #ffffff;
                }
            }
            div {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
            }
            .left-title {
                width: 78%;
                display: flex;
                justify-content: flex-start;
                font-size: 14px;
            }
            .right-icon {
                width: 17%;
            }
        }
        .grande-cont {
            width: 100%;
            &:hover {
                background: #434855;
                border-radius: 3px;
                .sub-icon {
                    .icon-color {
                        color: #ffffff;
                    }
                }
            }
            &.subChildActive {
                background: #215de8;
                border-radius: 3px;
                color: #ffffff;
                .sub-icon {
                    .icon-color {
                        color: #ffffff;
                    }
                }
            }
            .grandeItem {
                padding-left: 50px;
                cursor: pointer;
            }
        }
    }
    .admin-footer {
        height: 50px;
        position: fixed;
        bottom: 0px;
        background-color: #282c33;
        width: 230px !important;
        box-sizing: border-box;
        border-top: 2px solid #000;
        padding: 0 5px;
        align-items: center;
        display: flex;
        color: #ffffff;
        font-size: 14px;
        .admin-img {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            overflow: hidden;
            margin-top: 10px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .userName {
            height: 100%;
            margin: 0 10px;
            line-height: 50px;
            color: #ffffff;
            display: inline-block;
            width: 70px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .el-dropdown-link {
            color: #ffffff;
            display: inline-block;
            width: 136px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    // background-color: #f5f5f5;
}
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(10, 10, 10, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/views/components/Menu/z-menu.vue